import { ButtonProps, Button as MuiButton, styled } from "@mui/material";

const CustomMMuiButton = styled(MuiButton)<ButtonProps>(({ theme }) => ({
  textTransform: 'none',
}));


export default function Button({ children, ...props }: ButtonProps) {
  return (
    <CustomMMuiButton {...props}>
      {children}
    </CustomMMuiButton>
  );
}